import * as _4 from 'lodash4';
import { TermPinModel } from '../models/term_pin_model';
export class TermPinServant {
  constructor(private ngTermPinModel: TermPinModel, private appConfigModel: any) {}

  isTermPinFeatureEnabled() {
    return this.appConfigModel.model.member_features['reg-term_permission'];
  }

  hasTermPin() {
    return this.ngTermPinModel.read().term_pin !== '';
  }
  shouldUpdateTermPin() {
    return this.ngTermPinModel.read().isPinUpdated;
  }
}

angular.module('capability-ng-scheduler').service('ngTermPinServant', TermPinServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/term_pin/servants/term_pin_servant.ts